/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersMutationRequest, PostUsersMutationResponse, PostUsers400 } from '../entities/PostUsers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersUrl() {
  return `/users` as const
}

/**
 * @description Создание пользователя админом компании
 * @summary Создание пользователя
 * {@link /users}
 */
export async function postUsers(data: PostUsersMutationRequest, config: Partial<RequestConfig<PostUsersMutationRequest>> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUsersMutationResponse, ResponseErrorConfig<PostUsers400>, PostUsersMutationRequest>({
    method: 'POST',
    url: getPostUsersUrl().toString(),
    data,
    ...requestConfig,
  })
  return res.data
}